/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class QuantityField extends React.PureComponent {
  render() {
    const { value, onChange, disabled } = this.props

    return (
      <Form.Field required>
        <label>Quantity</label>
        <Input
          required={!disabled}
          disabled={disabled}
          placeholder="e.g 10"
          type="number"
          onChange={e => onChange(e.target.value)}
          value={value}
          min={1}
          step={1}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/quantityField.js